export default __webpack_public_path__ + "static/media/unshare.f650ad4a.svg";